import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ProjectCommentsRecordWidget from '../../../widgets/projectCommentsRecordWidgets/ProjectCommentsRecordWidget'
import { getCommentation } from '../../../redux/actions/subprojectCommentation'

export default function ProjectCommentsRecord() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const projectCode = sessionStorage.getItem('projectCode')
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getCommentation(projectId, projectCode)
      setSchema(response)
      //setSchema(mockSchema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProjectDep6>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProjectDep6>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isSubProjectDep6>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi />

        <ProjectCommentsRecordWidget schema={schema} />

        <br />
      </SidebarProposal>
    </div>
  )
}

const mockSchema = {
  affectedRows: 0,
  message: null,
  didError: false,
  errorMessage: null,
  model: {
    form: {
      formInput: {
        header: 'บันทึกการให้ความเห็นต่อโครงการ',
        notesInput: {
          name: 'notesInput',
          label: 'สรุปความเห็นโครงการและรายงานความก้าวหน้าโครงการ',
          value: 0,
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอกสรุปความเห็นโครงการและรายงานความก้าวหน้าโครงการ',
            },
          ],
        },
      },
      data: {
        totalSize: 6,
        values: [
          {
            id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
            dateFollow: '01/02/2024',
            notesInput: 'เจ้าหน้าที่โครงการทำกิจกรรมได้ตามเป้าหมาย',
            commentator: 'นาย A',
            totalSize: 3,
          },
          {
            id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
            dateFollow: '15/04/2024',
            notesInput: 'ขาดการประสานงานทำให้อาจส่งงานล่าช้าได้',
            commentator: 'นาย B',
            totalSize: 3,
          },
          {
            id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
            dateFollow: '01/02/2024',
            notesInput: 'โครงการมีโอกาสล่าช้าจากการติดตามผล',
            commentator: 'นาย C',
            totalSize: 3,
          },
        ],
      },
    },
    header: 'บันทึกการให้ความเห็นต่อโครงการ',
    subHeader: null,
    disabled: true,
    isApprover: false,
    isReadOnly: true,
  },
}
